export default __webpack_public_path__ + "static/media/filter-icon.760a5627.svg";